import React, { useContext } from "react";
import "./notFound.css";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../../context/combinedContext";

const COPY = {
	es: {
		title: "Página no encontrada",
		subtitle: "La página que buscas no existe o fue movida.",
		button: "Volver al inicio",
	},
	en: {
		title: "Page not found",
		subtitle: "The page you're looking for doesn't exist or has moved.",
		button: "Back to home",
	},
};

const NotFound = () => {
	const navigate = useNavigate();
	const ctx = useContext(CombinedContext);
	const language = ctx?.language === "en" ? "en" : "es";
	const t = COPY[language];

	return (
		<div className="sf-404-wrapper">
			<div className="sf-404-content">
				<div className="sf-404-code">404</div>

				<h1 className="sf-404-title">{t.title}</h1>
				<p className="sf-404-subtitle">{t.subtitle}</p>

				<button
					type="button"
					className="sf-404-btn"
					onClick={() => navigate("/")}
				>
					{t.button}
				</button>
			</div>
		</div>
	);
};

export default NotFound;